import React from 'react';
import Card from '../components/Card';
import Button from '../components/Button';
import homeBg from '../home_bg.jpg';

const Home = () => {
    return (
        <>
            {/* Hero Section */}
            <section className="new-hero" style={{
                backgroundImage: `url(${homeBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}>
                <div className="hero-container">
                    <h1 className="hero-title-new">
                        Master <span className="highlight">THE ART OF SILAMBAM</span><br />
                        Become A Tamil Warrior
                    </h1>



                    <div className="hero-cta">
                        <Button
                            to="/courses"
                            style={{ margin: '0.5rem', fontSize: '1.1rem', padding: '1.2rem 2.5rem' }}
                        >
                            Explore Courses
                        </Button>
                    </div>
                </div>
            </section>

            {/* What is Silambam Section */}
            <section className="section section-dark">
                <div className="section-header">
                    <h2 className="section-title">What is Silambam?</h2>
                </div>
                <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
                    <p style={{ fontSize: '1.2rem', lineHeight: '1.8' }}>
                        Silambam is an ancient Tamil martial art that dates back over 5,000 years. It is a dynamic weapon-based fighting
                        system that emphasizes speed, agility, and precision. The art uses various traditional weapons including the bamboo
                        staff, flexible sword (Surul Vaal), deer horn (Maan Kombu), and double sticks. Silambam is not just about combat—it's a
                        complete system for physical fitness, mental discipline, and cultural preservation.
                    </p>
                </div>
            </section>

            {/* Why Learn Silambam Section */}
            <section className="section section-gradient">
                <div className="section-header">
                    <h2 className="section-title">Why Learn Silambam?</h2>
                </div>
                <div className="cards-grid">
                    <Card icon="🔱" title="Ancient Tradition" text="Connect with 5,000 years of Tamil warrior heritage and preserve a dying martial art for future generations." />
                    <Card icon="⚡" title="Complete Fitness" text="Develop strength, flexibility, coordination, and cardiovascular endurance through dynamic weapon training." />
                    <Card icon="🧠" title="Mental Discipline" text="Sharpen focus, improve reaction time, and build warrior-like mental resilience and confidence." />
                    <Card icon="🛡️" title="Self-Defense" text="Master practical combat techniques and develop the ability to defend yourself with or without weapons." />
                    <Card icon="🎭" title="Artistic Expression" text="Learn beautiful choreographies and artistic movements that showcase the grace and power of Silambam." />
                    <Card icon="💻" title="Train Anywhere" text="Join live online classes from anywhere in the world with personalized instruction and recorded sessions." />
                </div>
            </section>

            {/* Courses Overview Section 
            {/* <section className="section section-dark">
                <div className="section-header">
                    <h2 className="section-title">Courses Offered</h2>
                </div>
                <div className="cards-grid">
                    <Card title="Silambam Staff Training">
                        <p className="card-text">Master the bamboo staff from basic grips to advanced combat techniques. Available in Beginner, Intermediate, and Professional levels.</p>
                        <Button to="/courses#silambam" variant="secondary" style={{ marginTop: '1rem' }}>Learn More</Button>
                    </Card>
                    <Card title="Surul Vaal (Flexible Sword)">
                        <p className="card-text">Train with the iconic flexible sword, mastering circular movements, artistic spins, and attack-defense flows.</p>
                        <Button to="/courses#surul-vaal" variant="secondary" style={{ marginTop: '1rem' }}>Learn More</Button>
                    </Card>
                    <Card title="Maan Kombu (Deer Horn)">
                        <p className="card-text">Learn combat grips, locking techniques, and traditional footwork with this unique weapon system.</p>
                        <Button to="/courses#maan-kombu" variant="secondary" style={{ marginTop: '1rem' }}>Learn More</Button>
                    </Card>
                    <Card title="Double Stick Training">
                        <p className="card-text">Develop dual-hand coordination, rapid strikes, and rhythm drills with the double stick system.</p>
                        <Button to="/courses#double-stick" variant="secondary" style={{ marginTop: '1rem' }}>Learn More</Button>
                    </Card>
                    <Card title="Pro Combat Training">
                        <p className="card-text">Advanced sparring, competition preparation, and professional-level techniques for serious practitioners.</p>
                        <Button to="/courses#pro-combat" variant="secondary" style={{ marginTop: '1rem' }}>Learn More</Button>
                    </Card>
                    <Card title="All Weapons Mastery">
                        <p className="card-text">Complete curriculum covering all traditional Silambam weapons and combat systems.</p>
                        <Button to="/courses" variant="secondary" style={{ marginTop: '1rem' }}>View All Courses</Button>
                    </Card>
                </div>
                <div style={{ textAlign: 'center', marginTop: '3rem' }}>
                    <Button to="/courses">View Complete Course Catalog</Button>
                </div>
            </section> */}

            {/* Student Reviews Section */}
            <section className="section section-gradient">
                <div className="section-header">
                    <h2 className="section-title">Student Video Reviews</h2>
                </div>
                <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
                    <p style={{ fontSize: '1.2rem', marginBottom: '2rem' }}>
                        Hear from our students who have transformed their lives through Silambam training.
                    </p>
                    <div className="cards-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))' }}>
                        <div className="testimonial-card">
                            <p className="testimonial-text">"Learning Silambam online has been an incredible journey. The training is intense, authentic, and the cultural connection is profound."</p>
                            <p className="testimonial-author">Raj Kumar</p>
                            <p className="testimonial-role">regular Student</p>
                        </div>
                        <div className="testimonial-card">
                            <p className="testimonial-text">"I started as a complete beginner and now I can perform advanced staff techniques. The structured curriculum is excellent."</p>
                            <p className="testimonial-author">Priya Devi</p>
                            <p className="testimonial-role">regular Student</p>
                        </div>
                        <div className="testimonial-card">
                            <p className="testimonial-text">"The fitness transformation has been amazing. Silambam is the most complete workout I've ever experienced."</p>
                            <p className="testimonial-author">Pavithra</p>
                            <p className="testimonial-role">regular Student</p>
                        </div>
                    </div>
                    <div style={{ marginTop: '2rem' }}>
                        <Button to="/testimonials" variant="secondary">Read All Testimonials</Button>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="section section-dark" style={{ textAlign: 'center', padding: '5rem 2rem' }}>
                <h2 style={{ fontSize: '3rem', marginBottom: '1.5rem' }}>Ready to Begin Your Warrior Journey?</h2>
                <p style={{ fontSize: '1.3rem', marginBottom: '2rem', color: 'var(--color-gold-light)' }}>
                    Join thousands of students worldwide who are mastering this ancient Tamil martial art.
                </p>
                <div className="btn-group">
                    <Button to="/registration" style={{ fontSize: '1.2rem', padding: '1.2rem 3rem' }}>Enroll Now</Button>
                    <Button to="/schedule" variant="secondary" style={{ fontSize: '1.2rem', padding: '1.2rem 3rem' }}>View Class Schedule</Button>
                </div>
            </section>
        </>
    );
};

export default Home;
